import React from 'react';
import $ from 'jquery';
import UserSettings from './OtherSettings/UserSettings';
import ContentDataSettings from './OtherSettings/ContentDataSettings';
import { setLocalStorage, validateField, updateSize } from '../../../helpers/tools';

class OtherSettings extends React.Component {
  constructor(props) {
    super(props);

    this.sections = {
      user: { isValid: true },
      content: { isValid: true },
    };
  }

  componentDidMount() {
    updateSize();
  }

  handleOptionChange = (event, caller) => {
    const target = event.target;
    const configurationSection = caller.section;

    let value = target.value;
    let conf = this.props.data;
    let valid = true;
    this.sections[configurationSection].isValid = this.isValid(event, caller);

    Object.keys(this.sections).forEach(
      (item => {
        valid = valid && this.sections[item].isValid;
      }).bind(this)
    );

    conf.isValid = valid;
    conf[configurationSection][target.name] = value;

    this.props.updateState(conf);
  };

  isValid = (event, scope) => {
    let isValid = true;
    let errorItem = $(event.target).parent().find('.validationError');

    if (scope.invalidFileds.indexOf(event.target.name) > -1) {
      scope.invalidFileds.splice(scope.invalidFileds.indexOf(event.target.name), 1);
    }
    if ($(errorItem).get(0) && $(errorItem).get(0).style['display'] === 'block') {
      isValid = false;
      scope.invalidFileds.push(event.target.name);
    }
    setLocalStorage(scope.section + 'errors', JSON.stringify(scope.invalidFileds));

    return isValid && !scope.invalidFileds.length;
  };

  validate = (event, type, required, caller) => {
    const valueType = type === 'number' ? Number : String;
    validateField(
      event,
      type,
      required,
      this.handleOptionChange.bind(this, event, caller, valueType),
      1
    );
  };

  render() {
    return (
      <div>
        <UserSettings
          handleOptionChange={this.handleOptionChange}
          user={this.props.data.user}
          validate={this.validate}
        />
        <div className="divider"></div>
        <ContentDataSettings
          handleOptionChange={this.handleOptionChange}
          content={this.props.data.content}
          validate={this.validate}
        />
      </div>
    );
  }
}

export default OtherSettings;
